import { render, staticRenderFns } from "./email.vue?vue&type=template&id=90db50c8&"
import script from "./email.vue?vue&type=script&lang=js&"
export * from "./email.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('90db50c8')) {
      api.createRecord('90db50c8', component.options)
    } else {
      api.reload('90db50c8', component.options)
    }
    module.hot.accept("./email.vue?vue&type=template&id=90db50c8&", function () {
      api.rerender('90db50c8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/svg/email.vue"
export default component.exports